export default __webpack_public_path__ + "static/hp-brand-deck-04-9c65c761d30b0d1fbad53c5e6bb3d250.png";